export default {
    app: {
        title: 'Screen Size Checker',
        subtitle: 'A handy tool to measure the width, height, and inches of your display screen',
        description: 'Screen Size Checker is a handy tool that allows you to measure the width, height, and inches of your display screen.',
        width: 'Width',
        height: 'Height',
        diagonal: 'Diagonal',
        inches: 'Inches',
        pixels: 'Pixels',
        screen_size: 'Screen Size',
        resolution: 'Resolution',
        aspect_ratio: 'Aspect Ratio',
        pixel_density: 'Pixel Density',
        ppi: 'PPI (Pixels Per Inch)',
        device_info: 'Device Information',
        browser: 'Browser',
        os: 'OS',
        language: 'Language',
        home: 'Home',
        privacy_policy: 'Privacy Policy'
    }
};
